import styled from 'styled-components'

type IllustrationProps = {
  image: any
}

export const Illustration = styled.div<IllustrationProps>`
  background-image: url(${({ image }) => image});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  height: 95%;
  width: 100%;
`;